<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      :short-title="$t('checklist.sidebar.shortTitle')"
      :logo="$store.getters.systemLogoSidebar"
      :titleImg="$store.getters.systemTitleImage"
      :title="$store.getters.systemTile"
    >
      <template slot="links">
        <!-- slot-scope="props" -->
        <div v-if="$store.getters.isCargoKanbamAvaliable">
          <sidebar-item
            :link="{
              name: $t('sidebar.kanbanCargas'),
              icon: 'tim-icons icon-chart-pie-36',
              path: '/trackingShippingCompany/cargo/kanban', // '/trackingShippingCompany/dashboard/default',
            }"
          >
          </sidebar-item>
        </div>

        <div v-if="$store.getters.isCargoExpensesAvaliable">
          <sidebar-item
            :link="{
              name: $t('sidebar.kanbanFinanceiro'),
              icon: 'tim-icons icon-chart-bar-32',
              path: '/trackingShippingCompany/cargoExpense/kanban',
            }"
          >
          </sidebar-item>
        </div>
        <div v-if="$store.getters.hasAccessCompany == true">
          <sidebar-item
            :link="{
              name: $t('sidebar.empresas'),
              path: '/trackingShippingCompany/company/list',
              icon: 'tim-icons icon-bank',
            }"
          ></sidebar-item>
        </div>

        <div v-if="$store.getters.hasAccessUser == true">
          <sidebar-item
            :link="{
              name: $t('sidebar.usuarios'),
              path: '/trackingShippingCompany/user/list',
              icon: 'tim-icons icon-single-02',
            }"
          ></sidebar-item>
        </div>

        <div v-if="$store.getters.hasAccessProfile == true">
          <sidebar-item
            :link="{
              name: $t('system.profile.sidebar'),
              path: '/trackingShippingCompany/profile/all',
              icon: 'tim-icons icon-single-02',
            }"
          ></sidebar-item>
        </div>
        <sidebar-item
          v-if="isMasterAdmin"
          :link="{
            name: $t('system.module.sidebar'),
            path: '/trackingShippingCompany/module/all',
            icon: 'tim-icons icon-components',
          }"
        ></sidebar-item>
        <div v-if="$store.getters.hasAccessTypeOccurrence == true">
          <sidebar-item
            :link="{
              name: $t('sidebar.tracking.occurrenceType'),
              path: '/trackingShippingCompany/occurrenceType/list',
              icon: 'tim-icons icon-notes',
            }"
          ></sidebar-item>
        </div>

        <div v-if="$store.getters.hasAccessTypeOccurrenceExpense == true">
          <sidebar-item
            :link="{
              name: $t('sidebar.tracking.cargoExpenseOccurrence'),
              path: '/trackingShippingCompany/cargoExpenseOccurrence/list',
              icon: 'tim-icons icon-coins',
            }"
          ></sidebar-item>
        </div>

        <div v-if="$store.getters.hasAccessTypeVehicle == true">
          <sidebar-item
            :link="{
              name: $t('sidebar.tracking.vehicleType'),
              path: '/trackingShippingCompany/vehicleType/list',
              icon: 'tim-icons icon-delivery-fast',
            }"
          ></sidebar-item>
        </div>

        <div v-if="$store.getters.hasAccessLoads == true">
          <sidebar-item
            :link="{
              name: $t('sidebar.tracking.cargo'),
              path: '/trackingShippingCompany/cargo/list',
              icon: 'tim-icons icon-app',
            }"
          ></sidebar-item>
        </div>

        <div>
          <sidebar-item
            :link="{
              name: $t('sidebar.tracking.rotogram'),
              icon: 'tim-icons icon-square-pin',
              path: '/trackingShippingCompany/cargo/rotogram',
            }"
          />
        </div>

        <div v-if="$store.getters.hasAccessNonAttendanceReason == true">
          <sidebar-item
            :link="{
              name: $t('sidebar.tracking.nonAttendanceReason'),
              path: '/trackingShippingCompany/nonAttendanceReason/list',
              icon: 'tim-icons icon-paper',
            }"
          ></sidebar-item>
        </div>
        <div v-if="$store.getters.isAdministrator == true">
          <sidebar-item
            :link="{
              name: $t('tracking.disapprovedReason.sidebar'),
              path: '/trackingShippingCompany/disapprovedReason/list/',
              icon: 'tim-icons icon-paper',
            }"
          ></sidebar-item>
        </div>

        <!-- 
        <sidebar-item
          :link="{ 
              name: $t('sidebar.tracking.cargoExpense'),
              path: '/trackingShippingCompany/cargoExpense/list',
              icon: 'tim-icons icon-coins' 
            }"
        ></sidebar-item> -->

        <!-- <sidebar-item
          :link="{
            name: $t('sidebar.ocorrenciasdepara'),
            path: '/trackingShippingCompany/occurrencyFromTo/list',
            icon: 'tim-icons icon-bullet-list-67',
          }"
        ></sidebar-item> -->
      </template>
    </side-bar>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar module="trackingShippingCompany"></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
    <!-- <div> {{$store.getters}} </div> -->
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
//import SidebarShare from "./SidebarSharePlugin";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

// function initScrollbar(className) {
//   if (hasElement(className)) {
//     new PerfectScrollbar(`.${className}`);
//   } else {
//     // try to init it later in case this component is loaded async
//     setTimeout(() => {
//       initScrollbar(className);
//     }, 100);
//   }
// }

import DashboardNavbar from "@/pages/Layout/DashboardNavbar.vue";
import ContentFooter from "../../../pages/Layout/ContentFooter.vue";
import SidebarFixedToggleButton from "../../../pages/Layout/SidebarFixedToggleButton.vue";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  name: "TrackingShippingCompanyLayout",
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    ZoomCenterTransition,
  },
  data() {
    return {
      sidebarBackground: "primary", //vue|blue|orange|green|red|primary
      isMasterAdmin: false,
    };
  },
  created() {
    this.getUserMaster();
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    getUserMaster() {
      this.$apiScheduler
        .get("/module/getUserMaster/")
        .then((response) => {
          this.isMasterAdmin = response.data;
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    // initScrollbar() {
    //   let docClasses = document.body.classList;
    //   let isWindows = navigator.platform.startsWith("Win");
    //   if (isWindows) {
    //     // if we are on windows OS we activate the perfectScrollbar function
    //     initScrollbar("sidebar");
    //     //initScrollbar("main-panel");
    //     initScrollbar("sidebar-wrapper");

    //     docClasses.add("perfect-scrollbar-off"); // docClasses.add("perfect-scrollbar-on");
    //   } else {
    //     docClasses.add("perfect-scrollbar-off");
    //   }
    // },
  },
  mounted() {
    // this.initScrollbar();
    if (this.$refs.sidebarItemForms) {
      if (this.$refs.sidebarItemForms.collapsed) {
        this.$refs.sidebarItemForms.collapseMenu();
      }
    }
    if (this.$refs.sidebarItemPendencies) {
      if (this.$refs.sidebarItemPendencies.collapsed) {
        this.$refs.sidebarItemPendencies.collapseMenu();
      }
    }
    if (this.$refs.sidebarItemSchedules) {
      if (this.$refs.sidebarItemSchedules.collapsed) {
        this.$refs.sidebarItemSchedules.collapseMenu();
      }
    }
  },
};
</script>

<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
/* example */
.ps {
  height: 100%;
}
</style>
